export const lendFoundryTimer = {
  infoPartOneTimer: { time: 20 },
  infoPartTwoTimer: { time: 20 },
  paymentReviewTimer: { time: 20 },
};
